import { makeStyles } from '@material-ui/core'
import theme from '../../../MuiTheme/theme'

export const useStyles = makeStyles(() => ({
  errorAlert: {
    marginBottom: 20,
  },
  success: {
    background: theme.palette.success.main,
  },
  errorButton: {
    background: theme.palette.error.main,
  },
  grid: {
    paddingTop: '0 !important',
    paddingBottom: '0 !important',
  },
}))
